import { PlayerDataGQL } from '../../../../Api'

export type SkillsParticipantsList = {
  fastestShot: PlayerDataGQL[]
  accuracy: PlayerDataGQL[]
  fastestPlayer: PlayerDataGQL[]
  goalie: PlayerDataGQL[]
  relay: PlayerDataGQL[]
}

export type WLLSkillsParticipantsList = {
  fastestShot: PlayerDataGQL[]
  accuracy: PlayerDataGQL[]
  fastestPlayer: PlayerDataGQL[]
  goalie: PlayerDataGQL[]
  relay: PlayerDataGQL[]
}

export type ChallengeItem = {
  name: string
  slug: SkillsKeys
  desc?: string
  winner: string
}

type SkillsList = {
  fastestShot: string[]
  accuracy: string[]
  goalie: string[]
  relay: string[]
}

type SkillsKeys = keyof SkillsList

type WLLSkillsList = {
  fastestShot: string[]
  accuracy: string[]
  goalie: string[]
  relay: string[]
}

type WLLSkillsKeys = keyof WLLSkillsList

export const skillsParticipants: SkillsList = {
  fastestShot: [
    'matt-campbell',
    'graeme-hossack',
    'jake-piseno',
    'owen-grant',
  ],
  accuracy: [
    'marcus-holman',
    'chris-kavanagh',
    'brennan-o-neill',
    'connor-fields',
  ],
  goalie: ['liam-entenmann', 'brett-dobson', 'logan-mcnaney', 'colin-kirst'],
  relay: ['chris-kavanagh', 'pat-kavanagh', 'jack-hannah', 'matt-campbell'],
}

export const wllSkillsParticipants: WLLSkillsList = {
  fastestShot: ['charlotte-north', 'emily-hawryschuk', 'erin-coykendall', 'ally-kennedy'],
  accuracy: ['charlotte-north', 'izzy-scane', 'sam-apuzzo', 'kenzie-kent'],
  goalie: ['kady-glynn', 'taylor-moreno', 'erin-o-grady', 'delaney-sweitzer'],
  relay: ['abby-bosco', 'dempsey-arsenault', 'sydni-black', 'ally-mastroianni'],
}

export const challengesArray: ChallengeItem[] = [
  {
    name: 'Goalie Wars',
    slug: 'goalie',
    desc: 'The PLL’s top goalies compete through a combination of saving and clearing. Each save counts as one point, with clears of varying difficulty providing score multipliers. 52 second rounds. High score wins. One Round. Four Athletes.',
    winner: '',
  },
  {
    name: 'Accuracy Challenge',
    slug: 'accuracy',
    desc: 'The best shooters in the world take the stage to demonstrate accuracy, precision, and efficiency of shooting. 30 seconds, unlimited shots, and 5 targets of equal value. High score wins.',
    winner: '',
  },
  {
    name: 'Fastest Shot',
    slug: 'fastestShot',
    desc: 'Who has the fastest shot in the PLL? Each athlete gets two attempts to hit the highest velocity. Fastest shot wins.',
    winner: '',
  },
  {
    name: 'Lacrosse Relay',
    slug: 'relay',
    desc: 'The Lacrosse Relay is a test of speed, agility, and precision. Participants sprint from one end to the top of the two-point line, navigate through an agility ladder and dodging course, then complete a wall ball sequence  before hitting a target. Two teams of four, each comprising 2 PLL pros and 2 WLL pros, compete.',
    winner: '',
  },
]

export const getParticipants = (comp: SkillsKeys, players: PlayerDataGQL[]) => {
  let participants: PlayerDataGQL[] = []
  let list = skillsParticipants[comp]
  list.map((slug) => {
    let participant = players.find((pl) => pl.slug === slug)
    if (participant) {
      participants.push(participant)
    }
    return
  })
  return participants
}

export const getWLLParticipants = (
  comp: WLLSkillsKeys,
  players: PlayerDataGQL[]
) => {
  let participants: PlayerDataGQL[] = []
  let list = wllSkillsParticipants[comp]
  list.map((slug) => {
    let participant = players.find((pl) => pl.slug === slug)
    if (participant) {
      participants.push(participant)
    }
    return
  })
  return participants
}